import { Spinner } from "@climatepartner/components/Spinner";
import { Suspense } from "react";

import { ANALYTICS_ROUTE_SEGMENTS } from "../../shared/routing/paths/analytics";
import {
  AnalyticsDashboardPage,
  AnalyticsRoute,
  AnalyticsTestDashboardPage,
  AnalyticsTestNewDashboardPage,
} from "./route-elements";

export const AnalyticsRoutes = {
  path: ANALYTICS_ROUTE_SEGMENTS.root,
  element: <AnalyticsRoute />,
  children: [
    {
      index: true,
      element: (
        <Suspense fallback={<Spinner />}>
          <AnalyticsDashboardPage />
        </Suspense>
      ),
    },
    {
      path: ANALYTICS_ROUTE_SEGMENTS.testDashboard,
      element: (
        <Suspense fallback={<Spinner />}>
          <AnalyticsTestDashboardPage />
        </Suspense>
      ),
    },
    {
      path: ANALYTICS_ROUTE_SEGMENTS.testNewDashboard,
      element: (
        <Suspense fallback={<Spinner />}>
          <AnalyticsTestNewDashboardPage />
        </Suspense>
      ),
    },
  ],
};
